import Swal from "sweetalert2";
import axios from "../../axios";
import { setAlert } from "./alert";
import { ADD_BUSINESS_TYPE, DELETE_BUSINESS_TYPE, GET_BUSINESS_TYPES, UPDATE_BUSINESS_TYPE, UPDATE_BUSINESS_TYPE_STATUS } from "../types";
import { getErrorMessage } from "../../helpers/ErrorMessage";

export const addBusinessType = (formData) => async (dispatch) => {
  try {
    const res = await axios.post("business/type/add", formData);
    if (res.data.code === 1) {
      dispatch({ type: ADD_BUSINESS_TYPE, payload: res.data.data });
      Swal.fire({
        title: 'Success!',
        text: res.data.message,
        icon: 'success',
    });
      dispatch(setAlert(res.data.message, "success"));
      if (res.data.code === 0) {
        console.log("here :", res.data.message);  
        Swal.fire({
          title: 'warning!',
          text: res.data.message,
          icon: 'warning',
      });
    }
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({
        title: 'warning!',
        text: res.data.message,
        icon: 'warning',
      });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
    // const errorMessage = err.response?.data?.message || "An unexpected error occurred";
    const errorMessage = getErrorMessage(err.response?.data);

    Swal.fire({
      title: "Error!",
      text: errorMessage,
      icon: "error",
    });
  }
};
export const getBusinessType = () => async (dispatch) => {
  try {
    const res = await axios.get("business/type/all");
    // console.log("state :", res.data);
    if (res.data.code === 1) {
      dispatch({ type: GET_BUSINESS_TYPES, payload: res.data.data });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};


export const updateBusinessType = (formData) => async (dispatch) => {
  try {

    const updatedFormData = {
      id: formData.id,
      ...(formData.type && { type: formData.type }),
      ...(formData.dbname && { dbname: formData.dbname }),
      ...(formData.status !== undefined && { status: formData.status }),
    };
    
    const res = await axios.post("business/type/update", updatedFormData);
    if (res.data.code === 1) {
      dispatch({ type: UPDATE_BUSINESS_TYPE, payload: res.data.data });
      Swal.fire({
        title: 'Success!',
        text: res.data.message,
        icon: 'success',
    });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({
        title: 'warning!',
        text: res.data.message,
        icon: 'warning',
    });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};

export const updateBusinessTypeStatus = (formData) => async (dispatch) => {
  try {

    const updatedFormData = {
      id: formData.id,
      ...(formData.status !== undefined && { status: formData.status }),
    };
    
    const res = await axios.post("business/type/update/status", updatedFormData);
    if (res.data.code === 1) {
      dispatch({ type: UPDATE_BUSINESS_TYPE_STATUS, payload: res.data.data });
      Swal.fire({
        title: 'Success!',
        text: res.data.message,
        icon: 'success',
    });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({
        title: 'warning!',
        text: res.data.message,
        icon: 'warning',
    });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};

export const deleteBusinessType = (id) => async (dispatch) => {
  try {
    if (!id) {
      dispatch(setAlert("Please select any record", "warning"));
      return false;
    }
    const res = await axios.post(`business/type/delete/${id}`);
    if (res.data.code === 1) {
      dispatch({ type: DELETE_BUSINESS_TYPE, payload: { id } });
      Swal.fire({
        title: 'Success!',
        text: res.data.message,
        icon: 'success',
    });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};
